"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.createStyles = exports.Spinner = void 0;
var react_1 = __importDefault(require("react"));
var styles_1 = require("../../styles");
function Spinner(props) {
    var style = props.style;
    var _a = styles_1.useStyles(exports.createStyles, props), classes = _a.classes, css = _a.css;
    return react_1.default.createElement("span", { className: css(classes.spinner, style) });
}
exports.Spinner = Spinner;
Spinner.defaultProps = {
    size: 1,
    borderWidth: 2,
};
exports.createStyles = function (theme, _a) {
    var size = _a.size, borderWidth = _a.borderWidth;
    return ({
        spinner: {
            pointerEvents: 'none',
            fontSize: size + "rem",
            lineHeight: 1,
            ':after': {
                animation: theme.animation.spinAround + " 450ms infinite linear",
                border: borderWidth + "px solid currentColor",
                borderRadius: '50%',
                borderRightColor: 'transparent',
                content: '""',
                display: 'inline-block',
                height: size + "rem",
                width: size + "rem",
            },
        },
    });
};
//# sourceMappingURL=Spinner.js.map